import { getCookie } from '@/utils/tool'

// 获取facebook的唯一id
export const getFid = () => {
  const fid = getCookie('_fbp') || ''
  return fid
}
